import { UseCasePostCanidateByJob } from "./candidate/post-candidate-by-job";
import { UseCaseJobOpeningGetAIDescriptionByCargoId } from "./job-opening/description";
import { UseCaseJobOpeningGetFiltersInputData } from "./job-opening/get-filter-input-data";
import { UseCaseJobOpeningGetPanoramaById } from "./job-opening/getById";
import { UseCasePostLeadOpeningJob } from "./job-opening/post-lead-opening-job";
import { UseCasePostSendJobOpening } from "./job-opening/post-send-job-opening";
import { UseCasePostTalkToSpecialist } from "./job-opening/post-talk-to-specialist";
import { UseCaseGetJobById } from "./jobs/get-by-id";
import { UseCaseGetFinishedJobById } from "./jobs/get-finished-job-by-id";
import { UseCaseGetJobsCount } from "./jobs/get-job-count";
import { UseCaseGetMyJobs } from "./jobs/get-my-jobs";
import { UseCaseGetPushJobsList } from "./jobs/get-push-jobs-list";
import { UseCaseGetJobHistoryInputFilter } from "./jobs/historico/get-input-filters";
import { UseCasePostJobHistoryFiltered } from "./jobs/historico/post-job-history-filtered";
import { UseCaseGetJobHireStatistics } from "./jobs/statistics/get-job-hire-statistics";
import { UseCaseGetJobTalentStatistics } from "./jobs/statistics/get-job-talent-statistics";
import { UseCaseGetMyVacancies } from "./my-vacancies/get-my-vacancies";
import { UseCaseGetMyVacancyById } from "./my-vacancies/get-my-vacancy-by-id";
import { UseCaseGetStatistics } from "./my-vacancies/get-statistics";
import { UseCaseGetMetricsByJobId } from "./my-vacancies/metrics/get-metrics-by-job-id";
import { UseCasePostNPSVagas } from "./nps-vagas/create-nps-vagas";
import { UseCasePanoramaGetAboutPositionByJobId } from "./panorama/about-position/get-about-position-by-jobId";
import { UseCasePanoramaGetAverageWageByJobId } from "./panorama/average-wage/get-by-jobId";
import { UseCasePanoramaGetDadosArea } from "./panorama/dados-area";
import { UseCasePanoramaGetCargosByName } from "./panorama/getCargosByName";
import { UseCasePanoramaGetProfessionalProfileByJobId } from "./panorama/professional-profile/get-professional-profile-by-jobId";
import { UseCaseGetProfile } from "./profile/get-profile";
import { UseCasePostPushCanidateByJob } from "./push/candidate/post-candidate-by-job";
import { UseCasePostHireNewTalent } from "./push/create-hire-new-talent";
import { UseCaseReportCreateIssue } from "./report/create-report-issue";
import { UseCaseShortlistGetByJobId } from "./shortlist/get-by-jobId";
import { UseCaseNewShortlistGetByJobId } from "./shortlist/get-new-by-jobId";
import { UseCaseShortlistTalentEducationById } from "./shortlist/profile/talent/education/get-by-talent-id";
import { UseCaseGetExperienceByTalentId } from "./shortlist/profile/talent/experience/get-by-talent-id";
import { UseCaseShortlistGetSkillsByTalentId } from "./shortlist/profile/talent/skills/get-by-talent-id";
import { UseCaseShortlistProfileTalentGetSummaryByTalentId } from "./shortlist/profile/talent/summary/get-summary-by-talentId";
import { UseCaseShortlistGetPublicShortlist } from "./shortlist/public/get-public-shortlist";
import { UseCaseShortlistPublicGetTalents } from "./shortlist/public/get-talents-of-shortlist";
import { UseCaseShortlistTalentPostLikeTalent } from "./shortlist/talent/post-talent-like";
import { UseCaseSprintGetHomePage } from "./sprint/get-home-page";
import { UseCaseSprintSolicitarEntrevista } from "./sprint/solicitar-entrevista";
import { UseCaseSprintGetByTalentId } from "./sprint/talent/get-by-id";
import { UseCasePostSprintCanidateByJob } from "./sprint/talent/post-candidate-by-job";
import { UseCaseGetTalentProfileData } from "./talent/get-talent-profile-data";
import { UseCasePostTalentProfileData } from "./talent/post-talent-profile-data";
import { UseCaseCreateUser } from "./user/create-user";
import { UseCaseUpdateUser } from "./user/update-user";

export const UseCases = {
  talent: {
    getTalentProfileData: UseCaseGetTalentProfileData,
    postTalentProfileData: UseCasePostTalentProfileData,
  },
  report: {
    createIssue: UseCaseReportCreateIssue,
  },
  npsVagas: {
    postJobNPS: UseCasePostNPSVagas,
  },
  candidate: {
    getCandidateByJob: UseCasePostCanidateByJob,
  },
  panorama: {
    getProfessionalProfileByJobId: UseCasePanoramaGetProfessionalProfileByJobId,
    aboutPosition: {
      getAboutPositionByJobId: UseCasePanoramaGetAboutPositionByJobId,
    },
    getAverageWageByJobId: UseCasePanoramaGetAverageWageByJobId,
    getPanoramaDadosArea: UseCasePanoramaGetDadosArea,
    getPanoramaCargoByName: UseCasePanoramaGetCargosByName,
  },
  jobOpening: {
    postLeadOpeningJob: UseCasePostLeadOpeningJob,
    postTalkToSpecialist: UseCasePostTalkToSpecialist,
    postSendJobOpening: UseCasePostSendJobOpening,
    getPanoramaById: UseCaseJobOpeningGetPanoramaById,
    getFiltersInputData: UseCaseJobOpeningGetFiltersInputData,
    getAIDescriptionByCargoId: UseCaseJobOpeningGetAIDescriptionByCargoId,
  },
  jobs: {
    getPushJobsList: UseCaseGetPushJobsList,
    getJobById: UseCaseGetJobById,
    getMyJobs: UseCaseGetMyJobs,
    getJobsCount: UseCaseGetJobsCount,
    getFinishedJobById: UseCaseGetFinishedJobById,
    getInputByJobHistory: UseCaseGetJobHistoryInputFilter,
    getJobHistoryFiltered: UseCasePostJobHistoryFiltered,
  },
  vacancies: {
    getMyVacancies: UseCaseGetMyVacancies,
    getMyVacancyById: UseCaseGetMyVacancyById,
    metrics: {
      getMetricsByJobId: UseCaseGetMetricsByJobId,
    },
  },

  statistics: {
    getStatistics: UseCaseGetStatistics,
    getJobTalentStatistics: UseCaseGetJobTalentStatistics,
    getJobHireStatistics: UseCaseGetJobHireStatistics,
  },
  profile: {
    getProfile: UseCaseGetProfile,
  },
  push: {
    postHireNewTalent: UseCasePostHireNewTalent,
    postCandidateByJob: UseCasePostPushCanidateByJob,
  },
  shortlist: {
    getNewByJobId: UseCaseNewShortlistGetByJobId,
    getByJobId: UseCaseShortlistGetByJobId,
    public: {
      getPublicShortlist: UseCaseShortlistGetPublicShortlist,
      getTalentsOfShortlist: UseCaseShortlistPublicGetTalents,
    },
    talent: {
      postLikeTalent: UseCaseShortlistTalentPostLikeTalent,
    },
    profile: {
      talent: {
        getSummaryByTalentId: UseCaseShortlistProfileTalentGetSummaryByTalentId,
        getExperienceByTalentId: UseCaseGetExperienceByTalentId,
        getSkillsByTalentId: UseCaseShortlistGetSkillsByTalentId,
        getEducationById: UseCaseShortlistTalentEducationById,
      },
    },
  },
  user: {
    passwordRegistration: UseCaseCreateUser,
    socialRegistration: UseCaseUpdateUser,
  },
  sprint: {
    talent: {
      getById: UseCaseSprintGetByTalentId,
      postCandidateByJob: UseCasePostSprintCanidateByJob,
    },
    getHomePage: UseCaseSprintGetHomePage,
    solicitarEntrevista: UseCaseSprintSolicitarEntrevista,
  },
};
